module.exports = __webpack_public_path__ + "static/4-b7c5ea12c3e5e31f39141a178a494711.jpg";